
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { postAggregatorSerial } from "@/helpers/api";
import { Companies, Customers } from "@/interfaces/systemsdb";

export default defineComponent({
  name: "NewAggregatorModal",
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "save"],
  setup(props, { emit }) {
    const state = reactive({
      loading: false as boolean,

      saving: false as boolean,

      form: {
        name: null as string | null,
        sn: null as string | null,
      },
      errorMsg: "" as string,
    });

    const save = async () => {
      state.errorMsg = "";
      state.saving = true;

      try {
        await postAggregatorSerial({ ...state.form });

        emit("save", {
          form: {
            ...state.form,
          },
        });

        emit("close");
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to save aggregator";
      } finally {
        state.saving = false;
      }
    };

    const close = () => {
      emit("close");
    };

    return {
      ...toRefs(state),
      save,
      close,
      //postNewCustomer
    };
  },
});
